/* eslint-disable array-callback-return */
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import {
  createChapterRequest,
  editChapterRequest,
} from "../../../../modules/admin-modules/chapters/Actions";
import { closeCreateChapterModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllAdminSectionsRequest } from "../../../../modules/admin-modules/sections/Actions";
import { getAllSubjectsRequest } from "../../../../modules/admin-modules/subjects/Actions";

const baseUrl = "https://asquera.com/asquera";

const AddChapter = ({ isAdd, data, setSelectedData }) => {
  const [selected, setSelected] = useState("");
  const openChapter = useSelector((state) => state.model.isOpen11);
  const subjects = useSelector((state) => state.subjects.subjects);
  const isLoading = useSelector((state) => state.chapters.isLoading);
  const sections = useSelector((state) => state.adminSections.sections);

  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const sectionsOptions = sections?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const dispatch = useDispatch();
  useEffect(() => {
    if (openChapter) {
      dispatch(getAllSubjectsRequest());
      dispatch(getAllAdminSectionsRequest());
    }
  }, [openChapter]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const sectionId = watch("section_id");
  const selectedSection =
    sectionsOptions?.find((option) => option.value == sectionId) || null;

  useEffect(() => {
    if (openChapter && !isAdd && data?.section_id && sections?.length) {
      setValue("section_id", data.section_id);
    }
    if (!openChapter) {
      setSelected("");
    }
  }, [openChapter, isAdd, data?.section_id, sections?.length, setValue]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة الفصل" : "تعديل  الفصل"}
      </Heading>
    </Box>
  );
  const onSubmit = async (values) => {
    const action = () => {
      dispatch(closeCreateChapterModel());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      let formData = await new FormData();
      for (let key in values) {
        formData.append(key, values[key]);
      }
      if (values.section_id) {
        await dispatch(createChapterRequest(formData, action));
      } else {
        toast.error("اختر المادة");
      }
    } else {
      let formData = new FormData();
      formData.append("_method", "PUT");
      formData.append("name", values.name);
      formData.append("name_ar", values.name_ar);
      formData.append("section_id", values.section_id ?? data?.section_id);

      if (values.logo instanceof File) {
        formData.append("logo", values.logo);
      }

      dispatch(
        editChapterRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeCreateChapterModel());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openChapter}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="اسم الفصل باللغة الانجليزية"
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="ادخل اسم الفصل باللغة الانجليزية"
              register={register}
              name="name"
            />
          </Box>
          <Box w="45%">
            <MainInput
              label="اسم الفصل باللغة العربية"
              defaultValues={data?.name_ar}
              error={errors?.name_ar?.message}
              placeholder="ادخل اسم الفصل باللغة العربية"
              register={register}
              name="name_ar"
            />
          </Box>
          <Box w="45%">
            <FormLabel>رفع الصورة:</FormLabel>
            {!isAdd &&
              data?.logo &&
              data.logo !== "null" &&
              data.logo !== "NULL" && (
                <Box mb="3">
                  <FormLabel fontSize="sm" color="gray.600">
                    الشعار الحالي:
                  </FormLabel>
                  <Image
                    src={`${baseUrl}/${data.logo}`}
                    alt="chapter logo"
                    maxH="120px"
                    objectFit="contain"
                    borderRadius="8px"
                  />
                </Box>
              )}
            <Button
              bg="main_1"
              color="white"
              borderRadius="8px"
              textAlign="center"
              position="relative"
              w="100%"
            >
              <Text>{selected ? selected : "اختر ملف ليتم رفعه"} </Text>
              <Input
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setValue("logo", file);
                    setSelected(file.name);
                  }
                }}
                type="file"
                accept="image/*"
                placeholder="اختر ملف ليتم رفعه"
                opacity="0"
                position="absolute"
                w="100%"
                h="100%"
              />
            </Button>
          </Box>


          <Box w="45%">
            <Box w="100%">
              <FormLabel>الاقسام : </FormLabel>
              <Select
                key={isAdd ? "add-section" : `edit-section-${data?.id}`}
                options={sectionsOptions}
                value={selectedSection}
                onChange={(option) => setValue("section_id", option.value)}
                styles={colourStyles}
                placeholder="الاقسام"
              />
            </Box>
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddChapter;
